// AI Voice Dialer Configuration
export const voiceDialerConfig = {
  // Voice processing options
  voiceProvider: process.env.REACT_APP_VOICE_PROVIDER || 'webaudio', // 'voicemod', 'elevenlabs', 'webaudio'
  
  // Voicemod API Key (legacy)
  voicemodKey: process.env.REACT_APP_VOICEMOD_KEY || 'controlapi-AyNBJRKOV',
  
  // ElevenLabs API Key (cloud-based alternative)
  elevenLabsApiKey: process.env.REACT_APP_ELEVENLABS_API_KEY,
  
  // Telnyx SIP Credentials  
  telnyx: {
    username: process.env.REACT_APP_TELNYX_SIP_USERNAME || 'userraph71943',
    password: process.env.REACT_APP_TELNYX_SIP_PASSWORD || '5JMx0uRw',
    connectionId: process.env.REACT_APP_TELNYX_SIP_CONNECTION_ID || '2719940157288482788',
    callerNumber: process.env.REACT_APP_TELNYX_CALLER_NUMBER || '+13239967539', // Assigned phone number
    // Optional: JWT token for authentication (alternative to username/password)
    // DISABLED: Force credential authentication instead of token
    token: undefined // process.env.REACT_APP_TELNYX_TOKEN || undefined
  },
  
  // Voicemod port options (for local desktop app)
  voicemodPorts: [59129, 20000, 39273, 42152, 43782, 46667, 35679, 37170, 38501, 33952, 30546]
};

export default voiceDialerConfig; 